import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import * as fromProviders from '../../../../entities/providers/selectors';

import { i18n } from '../../../../i18n';
import { getPiraeusPosID } from '../../../../config/piraeus';

const langMapping = {
  en: 'en-US',
  ru: 'ru-RU',
  ua: 'ru-RU',
  el: 'el-GR',
};

interface Props {
  provider?: string;
  shipmentID?: string;
  linkID?: string;
}

export const PiraeusBanking: React.FC<Props> = ({ provider, shipmentID, linkID }) => {
  const formRef = useRef<HTMLFormElement>(null);
  const process = useSelector(fromProviders.isProcessPiraeus);

  const { language } = i18n;

  const locale = langMapping[language as keyof typeof langMapping] || langMapping.en;
  const posID = getPiraeusPosID(language);

  // submit form
  useEffect(() => {
    if (process && formRef.current) {
      formRef.current.submit();
    }
  }, [process, formRef]);

  return (
    <>
      <form hidden ref={formRef} action="https://paycenter.piraeusbank.gr/redirection/pay.aspx" method="POST">
        <input name="AcquirerId" type="hidden" value="14" />
        <input name="MerchantId" type="hidden" value="142444777" />

        <input name="PosId" type="hidden" value={posID} />

        <input name="Username" type="hidden" value="SM323250" />
        <input name="Password" type="hidden" value="fbc4a1f2c695d7ea99e5dc0e159273a4" />

        <input name="LanguageCode" type="hidden" value={locale} />

        <input name="MerchantReference" type="hidden" value={shipmentID ? `${provider}${shipmentID}` : linkID} />

        <button type="submit">submit</button>
      </form>
    </>
  );
};
